import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o'; 

// 1. Interface for Fun Facts
export interface FactItem {
  value: string;
  label: string;
  delay: string;
}

// 2. Interface for Testimonials
export interface TestimonialItem {
  id: string;
  name: string;
  profession: string;
  image: string;
  rating: number;
  comment: string;
}

@Component({
  standalone: false,
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.css'
})
export class TestimonialsComponent {
    // Fun Facts Data Array
    facts: FactItem[] = [
      {
        value: '99',
        label: 'Success in getting happy customer',
        delay: '.1s'
      },
      {
        value: '25',
        label: 'Thousands of successful business',
        delay: '.3s'
      },
      {
        value: '120',
        label: 'Total clients who love HighTech',
        delay: '.5s'
      },
      {
        value: '5',
        label: 'Stars reviews given by satisfied clients',
        delay: '.7s'
      }
    ];
  
    // Lifecycle Hooks
    ngOnInit(): void {
      // Initialization code (if any)
    }
  
    ngOnDestroy(): void {
      // Cleanup code (if any)
    }

  // Testimonial Owl Carousel Configuration
  customOptionsThree: OwlOptions = {
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    smartSpeed: 1000,
    dots: true,
    margin: 0,
    nav: false,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    responsive: {
      0: {
        items: 3
      },
      768: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  };

  // Testimonials Data Array
  testimonials: TestimonialItem[] = [
    {
      id: 'test-1',
      name: 'Luke Oliver',
      profession: 'Marketing Lead',
      image: 'assets/images/testimonial-1.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-2',
      name: 'Emma Doe',
      profession: 'Designer',
      image: 'assets/images/testimonial-2.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-3',
      name: 'Johnathan Doe',
      profession: 'App Developer',
      image: 'assets/images/testimonial-3.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    },
    {
      id: 'test-4',
      name: 'Ammy Doe',
      profession: 'UI/UX Designer',
      image: 'assets/images/testimonial-4.jpg',
      rating: 5,
      comment: 'Lorem ipsum dolor sit amet elit. Sed efficitur quis purus ut interdum aliquam dolor eget urna. Nam volutpat libero sit amet leo cursus, ac viverra eros morbi quis quam mi.'
    }
  ];

  // Helper method to render stars dynamically
  getStars(rating: number): number[] {
    return Array(rating).fill(0);
  }  
}
